import { render, staticRenderFns } from "./ItemsSearch.vue?vue&type=template&id=71308240&scoped=true"
import script from "./ItemsSearch.vue?vue&type=script&lang=js"
export * from "./ItemsSearch.vue?vue&type=script&lang=js"
import style0 from "./ItemsSearch.vue?vue&type=style&index=0&id=71308240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71308240",
  null
  
)

export default component.exports